import CloneButton from './component';

export default CloneButton;
